// extracted by mini-css-extract-plugin
export default {"list":"ProductBadges_list__-cTGm","center":"ProductBadges_center__uFDQQ","left":"ProductBadges_left__U8Gcc","right":"ProductBadges_right__Hzb0H"};